import axiosInstance from './axios.service';
import { loadPointsList } from './points.service';
import { constructCategoriesDTO } from '@/utils/categories.utils';

export const getCategoriesByPoint = async (data, headers = {}) => {
  const url = '/operator/categories/point';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    return response || [];
  } catch (error) {
    console.error('Error posting:axios:getCategoriesByPoint data:', error);
    throw error;
  }
};

export const getMerchantCategories = async (data = {}, headers = {}) => {
  const url = '/operator/v1/categories/list';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    return Array.isArray(response?.data) ? response.data : response || [];
  } catch (error) {
    console.error('Error posting:axios:getMerchantCategories data:', error);
    return [];
  }
};

export const getPointsCategories = async (data = {}, headers = {}) => {
  try {
    const pointsPromise = loadPointsList({}, headers);

    const goodsUrl = '/operator/v1/goods/read';
    // If data.pointId is undefined, we send an empty object as requested.
    // However, if data.pointId IS present, we construct the body.
    // Based on the user request "goodsBody может быть {}", let's make it conditional.
    // If data is empty or pointId is missing, send {}.
    // Wait, the user said "goodsBody может быть {}".
    // Let's just make goodsBody empty if data is not provided or empty.

    let goodsBody = {};
    if (data && Object.keys(data).length > 0) {
      goodsBody = {
        pointId: data.pointId,
        departmentId: data.departmentId || null,
        productIds: [],
        sku: '',
        deleted: false,
      };
    }

    const goodsPromise = axiosInstance.post(goodsUrl, goodsBody, { headers });

    // Fetch additional categories
    const extraCategoriesPromise = getMerchantCategories(data, headers).catch((err) => {
      console.warn('getMerchantCategories failed, ignoring:', err);
      return [];
    });

    const [pointsResponse, goodsResponse, extraCategoriesResponse] = await Promise.all([
      pointsPromise,
      goodsPromise,
      extraCategoriesPromise,
    ]);

    const pointsList = Array.isArray(pointsResponse)
      ? pointsResponse
      : Array.isArray(pointsResponse?.data)
        ? pointsResponse.data
        : [];

    const goodsData = goodsResponse || {};

    const goods = Array.isArray(goodsData)
      ? goodsData
      : Array.isArray(goodsData?.data)
        ? goodsData.data
        : goodsData.products || goodsData.goods || goodsData.items || [];
    let categories = goodsData.categories || [];

    const extraCategories = Array.isArray(extraCategoriesResponse)
      ? extraCategoriesResponse
      : Array.isArray(extraCategoriesResponse?.data)
        ? extraCategoriesResponse.data
        : [];

    // Merge categories ensuring uniqueness by ID
    // This ensures that empty categories (from categories/list) are preserved
    // even if they are not present in goods/list
    if (extraCategories.length > 0) {
      const categoryMap = new Map();
      categories.forEach((c) => categoryMap.set(c.id, c));
      extraCategories.forEach((c) => {
        if (!categoryMap.has(c.id)) {
          categoryMap.set(c.id, c);
        }
      });
      categories = Array.from(categoryMap.values());
    }

    // DTO Construction
    const result = constructCategoriesDTO(pointsList, categories, goods);

    return result;
  } catch (error) {
    console.error('Error posting:axios:getPointsCategories data:', error);
    return [];
  }
};

export const getMerchantCurrencySign = async () => {
  try {
    const { default: store } = await import('@/store');
    return store.dispatch('merchantCurrency/fetchCurrency');
  } catch (error) {
    console.error('Error posting:axios:getMerchantCurrencySign data:', error);
    return { error };
  }
};

/**
 * Creates a new point category.
 *
 * @param {object} data - The category data. Defaults to an object with a pointId, name, and isVisible property.
 * @param {object} headers - The headers to include in the request. Defaults to an empty object.
 * @return {object} The response from the API.
 */
export const setPointCategory = async (data, headers = {}) => {
  const url = '/operator/v1/categories/create';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    // console.log("response:axios:getMerchantCurrencySign", response);
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:getMerchantCurrencySign data:', error);
  }
};

export const updatePointCategory = async (data, headers = {}) => {
  const url = '/operator/v1/categories/update';
  try {
    const payload = { ...data };
    if (
      payload.categoryId != null &&
      payload.categoryId !== '' &&
      (payload.id == null || payload.id === '')
    ) {
      payload.id = payload.categoryId;
      delete payload.categoryId;
    }
    const response = await axiosInstance.post(url, payload, { headers });
    // console.log("response:axios:getMerchantCurrencySign", response);
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:getMerchantCurrencySign data:', error);
  }
};

export const updateCategoryVisibility = async (data, headers = {}) => {
  const url = '/operator/v1/categories/visibility/update';
  try {
    const payload = {
      categoryId: data.categoryId ?? data.id,
    };

    if (data.visibleForOperator !== undefined) payload.visibleForOperator = data.visibleForOperator;
    if (data.visibleForWaiter !== undefined) payload.visibleForWaiter = data.visibleForWaiter;
    if (data.visibleForCustomer !== undefined) payload.visibleForCustomer = data.visibleForCustomer;

    const response = await axiosInstance.post(url, payload, { headers });
    return response;
  } catch (error) {
    console.error('Error posting:axios:updateCategoryVisibility data:', error);
  }
};

//
export const dndPointCategories = async (data, headers = {}) => {
  const url = '/operator/v1/categories/shift';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    // console.log("response:axios:dndPointCategory", response);
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:dndPointCategory data:', error);
  }
};
export const dndProducts = async (data, headers = {}) => {
  const url = '/operator/v1/goods/shift';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:dndProduct data:', error);
  }
};
// ;
export const deletePointCategory = async (data, headers = {}) => {
  const url = '/operator/v1/categories/delete';
  try {
    const payload = { ...data };
    if (
      payload.categoryId != null &&
      payload.categoryId !== '' &&
      (payload.id == null || payload.id === '')
    ) {
      payload.id = payload.categoryId;
      delete payload.categoryId;
    }
    const response = await axiosInstance.post(url, payload, { headers });
    // console.log("response:axios:deletePointCategory", response);
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:deletePointCategory data:', error);
  }
};

export const axDeleteProduct = async (data, headers = {}) => {
  const url = '/operator/v1/goods/delete';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    // console.log("response:axios:deleteProduct", response);
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:deleteProduct data:', error);
  }
};
export const setNewProduct = async (data, headers = {}) => {
  const url = '/operator/v1/goods/create';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    // console.log("response:axios:setNewProduct", response);
    const result = response;
    return result;
  } catch (error) {
    console.error('Error posting:axios:setNewProduct data:', error);
  }
};
export const axUpdateProduct = async (data, headers = {}) => {
  const url = '/operator/v1/goods/update';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    // console.log("response:axios:axUpdateProduct", response);
    const result = response;
    return result;
  } catch (error) {
    // Enhanced error logging to help debugging rules issues
    if (error.response) {
      console.error('Error posting:axios:axUpdateProduct response status:', error.response.status);
      console.error('Error posting:axios:axUpdateProduct response data:', JSON.stringify(error.response.data, null, 2));
    } else {
      console.error('Error posting:axios:axUpdateProduct data:', error);
    }
    throw error; // Rethrow to let the caller handle it or see it in UI
  }
};

export const axUpdateProductVisibility = async (data, headers = {}) => {
  const url = '/operator/v1/goods/visibility/update';
  try {
    const payload = {
      productId: data.productId ?? data.id,
    };

    if (data.visibleForOperator !== undefined) payload.visibleForOperator = data.visibleForOperator;
    if (data.visibleForWaiter !== undefined) payload.visibleForWaiter = data.visibleForWaiter;
    if (data.visibleForCustomer !== undefined) payload.visibleForCustomer = data.visibleForCustomer;

    const response = await axiosInstance.post(url, payload, { headers });
    return response;
  } catch (error) {
    if (error.response) {
      console.error('Error posting:axios:axUpdateProductVisibility response status:', error.response.status);
      console.error('Error posting:axios:axUpdateProductVisibility response data:', JSON.stringify(error.response.data, null, 2));
    } else {
      console.error('Error posting:axios:axUpdateProductVisibility data:', error);
    }
    throw error;
  }
};

export const axUpdateProductWeightAdjustable = async (data, headers = {}) => {
  const url = '/operator/v1/goods/weight-adjustable/update';
  try {
    const response = await axiosInstance.post(url, data, { headers });
    return response;
  } catch (error) {
    if (error.response) {
      console.error('Error posting:axios:axUpdateProductWeightAdjustable response status:', error.response.status);
      console.error(
        'Error posting:axios:axUpdateProductWeightAdjustable response data:',
        JSON.stringify(error.response.data, null, 2),
      );
    } else {
      console.error('Error posting:axios:axUpdateProductWeightAdjustable data:', error);
    }
    throw error;
  }
};
